import { CheckIcon } from "@heroicons/react/outline";
import React from "react";

const All = () => {
  return (
    <div name="plat" className="w-full my-32">
      <div className="max-w-[1240px] m-auto px-2">
        <h2 className="text-5xl font-bold text-center">All-In-One Platform</h2>
        <p className="text-2xl py-8 text-center  text-gray-400">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores
          alias assumenda culpa possimus reiciendis sit ad officiis pariatur
          odit veritatis.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-4">
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>{" "}
          <div className="flex ">
            <div>
              <CheckIcon className="w-7 mr-4 text-green-600" />
            </div>

            <div>
              <h3 className="font-bold text-lg">Notification</h3>
              <p className="text-lg pt-2 pb-4">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptas libero voluptatem quibusdam aperiam incidunt velit!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default All;
